import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import ImageCard from '../image-card'
import ProductCard from '../product-card'
import Button from '../button'

import Gallery from './gallery'
import SpecTable from './spec-table'

import { generateResult, randomPickArray } from '../../utils/results'

import './index.styl'

const ProductDetail = props => {
  const {
    title,
    cat,
    type,
    pictures = [],
    description,
    sizes,
    allProducts,
    sitePrefix,
    productID,
    video,
    order,
  } = props

  const { t } =  useTranslation()

  const [selectedImg, setSelectedImg] = useState(pictures[0])
  const [relatedProducts, setRelatedProducts] = useState([])

  useEffect(()=>{
    setRelatedProducts(randomPickArray(allProducts, 3))
  }, [])

  return (
    <div className="product-detail">
      <div className="product-detail__main">
        {pictures.length > 0 && <Gallery pictures={pictures} />}
        <div
          className="product-detail__introduction"
          className={classNames('product-detail__introduction', {
            'product-detail__introduction--no-img': pictures.length === 0,
            'product-detail__introduction--contain-order': order,
          })}
        >
          <div className="product-detail__car-type">
            {type.label} - {cat.label}
          </div>
          <div className="product-detail__name">
          {
            title === productID 
            ? productID
            : `${productID} ${title}`
          }
          </div>
          {description.map((txt, i) => (
            <div key={i} className="product-detail__description">
              {txt}
            </div>
          ))}

          {
            order && (
              <Button className="product-detail__order-btn" style="primary" target="_blank" href={order}>
                {t('detail.order')}
              </Button>
            )
          }
        </div>
      </div>
      {sizes.length > 0 && (
        <div className="product-detail__spec">
          <div className="product-detail__sub-title">{t('detail.specification')}</div>
          <SpecTable items={sizes} />
        </div>
      )}
      {
        video && (
          <div className="product-detail__video-wrap">
            <iframe 
              className="product-detail__video-frame"
              src={`https://www.youtube.com/embed/${video.replace('https://www.youtube.com/watch?v=', '')}`}
              frameborder="0" 
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
              allowfullscreen
            />
          </div>
        )
      }
      <div className="product-detail__related-products">
        <div className="product-detail__sub-title">
          {t('detail.relatedProducts')}
        </div>
        <div className="product-detail__products-list">
          {relatedProducts.map((d, i) => (
            <ProductCard sitePrefix={sitePrefix} key={`${d.id}`} {...d} />
          ))}
        </div>
      </div>
    </div>
  )
}

ProductDetail.propTypes = {}

export default ProductDetail
